module.exports = __webpack_public_path__ + "static/img/zeng.7403e6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeng.jpg
// module id = 7zAZ
// module chunks = 1